'use client'

import Link from 'next/link'
import { useState } from 'react'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa6'

import { cn } from '@/lib/utils'

interface Props {
    parent: FooterNavMenuItem
}

const FooterNavDropdown = (props: Props) => {
    const { parent } = props
    const [isOpen, setisOpen] = useState(false)
    const menuItems = parent.children || []

    const handleToggle = () => {
        setisOpen(!isOpen)
    }

    return (
        <>
            <div
                title={parent.title}
                onClick={handleToggle}
                className="text-gray-200 hover:text-white flex items-center gap-3 cursor-pointer"
            >
                {parent.title}{' '}
                {!isOpen ? (
                    <FaAngleDown className="text-gray-200 hover:text-white" />
                ) : (
                    <FaAngleUp className="text-gray-200 hover:text-white" />
                )}
            </div>
            <ul
                className={cn(
                    'mt-4 ml-4 list-reset uppercase text-xs font-montserrat',
                    isOpen ? 'block' : 'hidden'
                )}
            >
                {menuItems.map((item) => (
                    <li key={item.title} className="mb-4">
                        <Link
                            href={item.href!}
                            title={item.title}
                            className="text-gray-200 hover:text-white"
                        >
                            {item.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </>
    )
}

export default FooterNavDropdown
